const getCompanyProfile = state => state.companyprofile.companyprofile

const selectors = {
    getCompanyProfile
}

export default selectors